import React, { Component } from 'react';
import InterfaceTooling from '../../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../../tooling/javascriptUtilsTooling';
import Constants from '../../../../definitions/constants';
import { FormattedMessage } from 'react-intl';
import Spinner from '../interface/spinner';

class FetchAutocompleteTextBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTimeoutObject: null,
      searchedValue: "",
      preLoading: false,
      minLength: props.minSearchLength !== undefined ? props.minSearchLength : 3
    };
  }
  
  componentDidUpdate(prevProps) {
    if(prevProps.loadingFetch == true && this.props.loadingFetch == false) {
      this.setState({
        preLoading: false
      })
    }
  }
  
  handleOnChange = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    this.setState({
      searchedValue: value
    })
    if(this.props.fetchAction && value.length>=this.state.minLength) {
      this.setState({
        preLoading: true
      });
      this.state.searchTimeoutObject = InterfaceTooling.delayCallAction(
        this.props.fetchAction.bind(null, value, event.currentTarget.dataset.searchdata),
        this.state.searchTimeoutObject
      );
    }
  };

  handleClickInput = (event) => {
    this.optionsWrapper.style.minWidth = this.inputText.getBoundingClientRect().width + "px";
    this.optionsWrapper.style.top = (this.inputText.getBoundingClientRect().top + this.inputText.getBoundingClientRect().height + 2) + "px";
    this.optionsWrapper.style.left = (this.inputText.getBoundingClientRect().left) + "px";
    this.handleOnChange(event);
  }

  handleOnClick = (event) => {
    let value = event.currentTarget.dataset.value;
    if(this.props.onClickOption) {
      this.props.onClickOption({
        currentTarget: {
          dataset: {
            path: this.props["data-path"],
            selectlist: this.props["data-selectlist"],
          },
          value: value
        }
      });
    }
    this.setState({
      searchedValue: ""
    });
  };

  handleOnResetSearchButton = (event) => {
    this.setState({
      searchedValue: ""
    });
  }
  
  render() {
    const {
      className,
      id,
      labelLocale,
      disabled,
      fetchAction,
      loadingFetch,
      fetchedData,
      forcedValue,
      onClickOption,
      showClearSearchButton,  //boolean: defines if the clear search button (at the end of the text input) is shown
    } = this.props;    
    const searchData = this.props["data-searchdata"];
    let finalFetchedData = fetchedData;
    if(finalFetchedData && !forcedValue && !this.props.fetchAction && this.state.searchedValue && this.state.searchedValue.length>=this.state.minLength) {
      finalFetchedData = finalFetchedData.filter(dataItem => dataItem.label.toUpperCase().indexOf(this.state.searchedValue.toUpperCase()) > -1);
    }
    return (
      <label className={"custom-input autocomplete-input matter-textfield-outlined" + (className ? " " + className : "") }>
        <input 
          id={id}
          placeholder=" "
          value={forcedValue ? forcedValue : this.state.searchedValue}
          type={Constants.interface.inputs.type.TEXT}                
          onChange={this.handleOnChange}
          onClick={this.handleClickInput}
          disabled={disabled}
          autoComplete={"false"}
          data-searchdata={searchData}
          ref={(input) => { this.inputText = input; }}
        />
        <span>{labelLocale}</span>
        <div className="options_wrapper" ref={(input) => { this.optionsWrapper = input; }}>
          {(this.state.searchedValue.length<this.state.minLength && this.state.minLength>1) ? (
            <div className="options_wrapper_inner">
              <div><FormattedMessage id="common.inputs.minSearchLength" values={{charLength: this.state.minLength}}/></div>
            </div>
          ) : (this.state.searchedValue.length>=this.state.minLength && (this.state.preLoading || loadingFetch)) ? (
            <div className="options_wrapper_inner">
              <div><Spinner/></div>
            </div>
          ) : (this.state.searchedValue.length>=this.state.minLength) ? ( 
            <div className="options_wrapper_inner" ref={(input) => { this.optionsWrapper = input; }}>
              {finalFetchedData && finalFetchedData.map((item,i) => {
                return (
                  <div 
                    onMouseDown={this.handleOnClick}
                    className="fetched_option" 
                    key={i}
                    data-value={item.value}
                    title={item.label}
                  >
                    {item.label}
                  </div>
                );
              })}
            </div>
          ) : null }
        </div>
        {(showClearSearchButton && this.state.searchedValue) && (
          <i 
            className="fas fa-times-circle"
            onClick={this.handleOnResetSearchButton}
          />
        )}
      </label>
    );
  }
}

export default FetchAutocompleteTextBox;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/fetchAutocompleteTextBox.jsx